module.exports = __webpack_public_path__ + "img/bitstamp-dark.05309e72.png";